import { render, staticRenderFns } from "./treatmentVolume.vue?vue&type=template&id=02a48dba&scoped=true&"
import script from "./treatmentVolume.vue?vue&type=script&lang=js&"
export * from "./treatmentVolume.vue?vue&type=script&lang=js&"
import style0 from "./treatmentVolume.vue?vue&type=style&index=0&id=02a48dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a48dba",
  null
  
)

export default component.exports